import {createModule} from '@/store'
import {User} from '@/typings/user'
import {getUserInfoAPI} from '@/api/auth'
import settings from '@/settings'
import {ElMenu, ElNotification} from 'element-plus'
import {getMenuList} from "@typings/menuList";

export default createModule({
    namespaced: true,
    state: {
        // 用户信息
        userInfo: {} as User,
        // websocket: null,
        // 当前选中的菜单
        // activeMenu: '',
    },
    mutations: {
        setUserInfo(state, value) {
            state.userInfo = value
        },
        // setActiveMenu(state, value) {
        //     state.activeMenu = value
        // },
        // setWebsocket(state, value) {
        //     state.websocket = new WebSocket(settings.WEBSOCKET + '/' + value)
        //     state.websocket.onopen = function () {
        //         console.log('已连接')
        //     }
        //     state.websocket.onclose = function () {
        //         console.log('已断开')
        //     }
        //     state.websocket.onopen = function () {
        //         console.log('已连接')
        //     }
        //     state.websocket.onmessage = function (e) {
        //         const data = JSON.parse(e.data)
        //         if (data.code !== 200) {
        //             ElNotification.warning(data.message)
        //         }
        //     }
        // },
    },
    actions: {
        // TODO 更新用户信息
        updateUserInfo({commit, dispatch}) {
            return new Promise((resolve, reject) => {
                getUserInfoAPI().then(res => {
                    if (res.result) {
                        res.result().then(async function (rdata) {
                            const {
                                payload: data
                            } = rdata
                            let permission = []
                            if (rdata.payload.menuId) {
                                permission = rdata.payload.menuId.split(',').map(function (item) {
                                    return item[0] === 'D' ? item.substring(1, item.length) : item
                                })
                                if (data.isManage) {
                                    permission.push('10', '16', '17')
                                }
                            }
                            data.role = data.roleId.toString()
                            data.permission = new Set(permission)
                            commit('setUserInfo', data)
                            // await dispatch('getProjectInfo', data.organizationId)
                            // commit('setWebsocket', data.id)
                            getMenuList()
                            resolve({state: true})
                        })
                    } else {
                        // 模拟用户信息
                        const data = res.data.payload.data
                        data.role = '1'
                        data.permission = new Set()
                        commit('setUserInfo', data)
                        resolve({state: true})
                    }
                }).catch(reject)
            })
        },
    },
    getters: {
        userInfo: state => state.userInfo,
        // activeMenu: state => state.activeMenu,
    },
})
